import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import "./CookieBanner.css";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    // Only render on these public routes
    const ALLOWED_PATHS = [
        "/",
        "/geo-search",
        "/name-search",
        "/dealer",
        "/register",
    ];

    // Prefix paths (any route that starts with these)
    const ALLOWED_PREFIXES = ["/dealer/"]; // <-- adds /dealer/:id pages

    const isAllowedRoute = (pathname) =>
        ALLOWED_PATHS.includes(pathname) ||
        ALLOWED_PREFIXES.some((p) => pathname.startsWith(p));

    useEffect(() => {
        // add class when banner is showing (no consent yet)
        document.documentElement.classList.toggle('cookie-banner-visible', visible);
    }, [visible]);

    useEffect(() => {
        const accepted = localStorage.getItem("cookieConsent") === "true";
        const loggedIn = localStorage.getItem("authToken") !== null;
        setVisible(!accepted && !loggedIn && isAllowedRoute(location.pathname));
    }, [location.pathname]);

    const handleAccept = () => {
        localStorage.setItem("cookieConsent", "true");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner" role="region" aria-label="Cookie notice">
            <p className="cookie-text">
                This site uses cookies and similar technologies essential for its operation.{" "}
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                    Learn more
                </a>
            </p>
            <button type="button" className="cookie-accept-btn" onClick={handleAccept}>
                <FontAwesomeIcon icon={faTimes} />
            </button>
        </div>
    );
}